import { motion } from "framer-motion";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { BsArrowRight } from "react-icons/bs";
import IntersectionBox from "../../animations/IntersectionBox";
import TrailingParagraph from "../../animations/TrailingParagraph";
import { fadeInFromRightWithDelay } from "../../animations/variants";
import GetQuoteSection from "../../components/GetQuoteSection";
import Layout from "../../components/layout";
import MapSection from "../../components/MapSection";
import Modal from "../../components/Modal";
import PlatformSection from "../../components/PlatformSection";
import ProcessDetails from "../../components/ProcessDetails";
import ManufacturingSolutions from "../../components/processes";
import QualitySection from "../../components/QualitySection";
import RequestCallback from "../../components/RequestCallback";
import SEO from "../../components/seo";

function MaterialCard({
  title,
  visible_description,
  expanded_description,
  grades,
  img,
  index,
}) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <motion.div
        className='card pim-material-card'
        whileHover={{ scale: 1.05 }}
        onClick={() => {
          setOpen(!open);
        }}>
        <p className='material-name'>{title} </p>
        <p className='material-description'>{expanded_description} </p>
        <p className='learn-more'>
          <BsArrowRight />
        </p>
      </motion.div>

      <Modal open={open} setOpen={setOpen}>
        <div className='material-modal'>
          <div className='content'>
            <h4 className='header'>{title}</h4>
            <div className='description'>{expanded_description}</div>
            {grades.length > 0 && (
              <div className='grades'>
                <ul>
                  {grades.map((grade, index) => (
                    <li>{grade}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

MaterialCard.defaultProps = {
  title: "Post Processing",
  visible_description: "Post Processing Description",
  expanded_description: "Post Processing Expanded Description",
  grades: [],
  img: "",
  index: 0,
};

function Materials({ title, materials }) {
  return (
    <div class='materials-avail-sec'>
      <p
        class='materials-head triggerAnimation animated'
        data-animate='fadeInUp'>
        <TrailingParagraph paragraph={title} />
      </p>
      <div className='materials-container container-fluid'>
        <div class='row materials-row pim-materials-row'>
          {materials.map((material, index) => (
            <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
              <MaterialCard
                title={material.material_name}
                visible_description=''
                expanded_description={material.material_description}
                grades={
                  material.material_grades
                    ? material.material_grades.split("\n")
                    : []
                }
                img={material.material_image?.image?.url}
                index={index}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

Materials.defaultProps = {
  materials: [
    {
      material_name: "Aluminium",
      material_grades: "Some Random Description",
      material_description_or_grades: "Description or goods",
      material_image: {
        image: {
          url: "",
        },
      },
    },
  ],
};

function PPCard({
  title,
  visible_description,
  expanded_description,
  grades,
  img,
  index,
}) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <motion.div
        className='card pim-pp-card'
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        onClick={() => {
          setOpen(!open);
        }}>
        <h4 className='pp-name processing-head'>{title} </h4>
        <div
          className='image'
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            height: "150px",
            backgroundPosition: "center",
          }}></div>
      </motion.div>

      <Modal open={open} setOpen={setOpen}>
        <div className='material-modal'>
          <div className='image'>
            <img src={img} alt={title} />
          </div>
          <div className='content'>
            <div className='header'>{title}</div>
            <div className='description'>
              {visible_description}&nbsp;{expanded_description}
            </div>
            {grades.length > 0 && (
              <div className='grades'>
                <ul>
                  {grades.map((grade, index) => (
                    <li>{grade}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

PPCard.defaultProps = {
  title: "Post Processing",
  visible_description: "Post Processing Description",
  expanded_description: "Post Processing Expanded Description",
  grades: [],
  img:
    "https://images.pexels.com/photos/1005644/pexels-photo-1005644.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  index: 0,
};

function PostProcessing({ title, pp }) {
  return (
    <div className='post-processing-section materials-section'>
      <p
        className='materials-head triggerAnimation animated'
        data-animate='fadeInUp'>
        <TrailingParagraph paragraph={title} />
      </p>
      <IntersectionBox>
        <div className='container-fluid'>
          <div className='row processing-row'>
            {pp.map((method, index) => (
              <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                <PPCard
                  title={method.PP_title}
                  visible_description={method.visible_text}
                  expanded_description={method.expanded_text}
                  index={index}
                  img={method.PP_image?.image?.url}
                />
              </div>
            ))}
          </div>
        </div>
      </IntersectionBox>
    </div>
  );
}

function PIMService() {
  const data = useStaticQuery(graphql`
    query {
      usps: strapi {
        services(where: { service: "cnc-machining" }) {
          service_usp {
            logo_title
            logo_image {
              image {
                url
              }
            }
          }
        }
      }
      strapi {
        services(where: { service: "plastic-injection-molding-services" }) {
          banner_image {
            image {
              url
              formats
            }
          }
          title_description {
            description_text
            heading_text
          }
          end_to_end_services {
            description_text
            heading_text
          }
          sub_service {
            expanded_text
            service_name
            visible_description
            icon {
              image {
                url
              }
            }
            popup_image {
              url
            }
          }
          usp_header
          service_usp {
            logo_title
            logo_image {
              image {
                url
              }
            }
          }
          materials_heading
          material_type {
            material_description
            material_grades
            material_name
            material_image {
              image {
                url
              }
            }
          }
          post_processing_title
          pp_type {
            PP_title
            expanded_text
            visible_text
            PP_image {
              image {
                url
              }
            }
          }

          map_service {
            map_title
            map_description
            map_number_title
            map_image {
              url
            }
          }
          platform_title
          platform_advantage {
            description_text
            heading_text
          }
          quality_section {
            description
            heading
            Certifications_list
            graphic {
              image {
                url
              }
            }
          }
          rcb_service {
            form_title_description {
              description_text
              heading_text
            }
          }
          get_quote_services {
            description_text
            heading_text
          }
          seo {
            title
            meta_description
            meta_keywords
          }
          service_detailed {
            heading
            description
            graphic {
              image {
                url
              }
            }
          }
        }
      }
    }
  `);

  const node = data.strapi.services[0];

  return (
    <Layout>
      <SEO
        title={node.seo.title}
        description={node.seo.meta_description}
        keywords={node.seo.meta_keywords}
      />
      <div className='content container-fluid'>
        <div className='service-info'>
          <div className='row service-row'>
            <div className='service-desc col-lg-5 col-md-5 col-sm-5 col-xs-12 '>
              <p className='service-desc-head'>
                <TrailingParagraph
                  paragraph={node.title_description.heading_text}
                />
              </p>
              <p className='service-desc-exp'>
                <TrailingParagraph
                  paragraph={node.title_description.description_text}
                />
              </p>
              <IntersectionBox threshold={0.1}>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className='clippy_button button-1'
                  onClick={() => {
                    window.open("/contact-us", "_blank");
                  }}>
                  Contact Us
                </motion.button>
              </IntersectionBox>
            </div>
            <div className='service-img col-lg-7 col-md-7 col-sm-7 col-xs-12'>
              <IntersectionBox variants={fadeInFromRightWithDelay(0.2)}>
                <img
                  src={node.banner_image.image.formats.medium.url}
                  alt='Plastic Injection Molding Services'
                />
              </IntersectionBox>
            </div>
          </div>
        </div>

        <ManufacturingSolutions
          title={node.end_to_end_services.heading_text}
          description={node.end_to_end_services.description_text}
          processes={node.sub_service}
        />

        <div class='service-features container-fluid'>
          <div
            class='row feature-row triggerAnimation animated'
            data-animate='fadeInUp'>
            <h2 className='usp-header'>
              <TrailingParagraph paragraph={node.usp_header} />
            </h2>
            {node.service_usp.map((service, index) => (
              <div class='column col-lg-3 col-md-3 col-sm-6 col-xs-6'>
                <IntersectionBox>
                  <div class='feature-icon'>
                    <img
                      src={service.logo_image.image.url}
                      alt={service.logo_title}
                    />
                  </div>
                  <p class='feature-desc'> {service.logo_title} </p>
                </IntersectionBox>
              </div>
            ))}
            {data.usps.services[0].service_usp
              .slice(2, 9)
              .map((service, index) => (
                <div class='column col-lg-3 col-md-3 col-sm-6 col-xs-6'>
                  <IntersectionBox>
                    <div class='feature-icon'>
                      <img
                        src={service.logo_image.image.url}
                        alt={service.logo_title}
                      />
                    </div>
                    <p class='feature-desc'> {service.logo_title} </p>
                  </IntersectionBox>
                </div>
              ))}
          </div>
        </div>
        <Materials
          title={node.materials_heading}
          materials={node.material_type}
        />
        <PostProcessing
          title={node.post_processing_title}
          pp={node.pp_type}></PostProcessing>
        <MapSection
          title={node.map_service.map_title}
          description={node.map_service.map_description}
          number={node.map_service.map_number_title}
        />
        <PlatformSection
          title={node.platform_title}
          tabs={node.platform_advantage}
        />
        <QualitySection
          title={node.quality_section.heading}
          description={node.quality_section.description}
          img={node.quality_section.graphic.image.url}
        />
        <ProcessDetails
          header={node.service_detailed.heading}
          description={node.service_detailed.description}
          img={node.service_detailed.graphic.image.url}
        />
        <RequestCallback
          title={node.rcb_service.form_title_description.heading_text}
          description={node.rcb_service.form_title_description.description_text}
        />
        <GetQuoteSection
          title={node.get_quote_services.heading_text}
          description={node.get_quote_services.description_text}
        />
      </div>
    </Layout>
  );
}

export default PIMService;
